import React from "react";
import Header from "../component/header/header";
import AboutUs from "../component/aboutUs";
import OurSolution from "../component/ourSolution";
import OurServices from "../component/ourServices";
import PhotoGallery from "../component/photoGalleryCarousel/photoGallery";
import ServicesPlan from "../component/servicePlan";
import OurPattern from "../component/ourPattern";
import ContactUs from "../component/contactUs";

export default function PristinePv() {
  return (
    <div className="mainBox">
      <Header></Header>
      <AboutUs></AboutUs>
      <OurSolution></OurSolution>
      <OurServices></OurServices>
      <PhotoGallery></PhotoGallery>
      <ServicesPlan></ServicesPlan>
      <OurPattern></OurPattern>
      <ContactUs></ContactUs>
    </div>
  );
}
